export type MarketingPageSlug =
  | "home"
  | "privacy"
  | "support"
  | "terms"
  | "features"
  | "pricing"
  | "faq"
  | "about";

export function marketingPageToPath(page: MarketingPageSlug) {
  switch (page) {
    case "features":
      return "/features";
    case "pricing":
      return "/pricing";
    case "faq":
      return "/faq";
    case "about":
      return "/about";
    case "privacy":
      return "/privacy";
    case "support":
      return "/support";
    case "terms":
      return "/terms";
    default:
      return "/";
  }
}
